<template>
    <b-card class="p-2 w-100 bg-white" body-class="p-2 border rounded shadow-sm">
        <!-- header-class="text-center p-0 w-100" -->
        <b-card-header @click="collapsed = !collapsed" role="tab" header-tag="header"
                       class="text-center font-weight-bold p-0 mx-0 w-100 bg-white" >
            <b-row align-h="between" align-v="center">
                <b-col  class="text-left">
                     <!-- Data -> "Donnée" -->
                     {{ $t('Data') }} {{ Index }}
                </b-col>
                <b-col class="d-flex justify-content-end">
                        <b-button v-if="collapsed" size="sm" class="border-0 bg-white text-black">
                             <!-- Close -> "Fermer" -->
                            <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5" role="button" />
                        </b-button>

                        <b-button v-else size="sm" class="border-0 bg-white text-black">
                            <!-- Open -> "Ouvrir" -->
                            <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5" role="button"  />
                        </b-button>

                        <b-button v-if="NbData > 1" size="sm" class="border-0 bg-white">
                             <!-- DeleteDataIndex -> "Supprimer Donnée 1" -->
                            <b-icon icon="x-lg" v-b-tooltip.hover :title="$t('DeleteDataIndex', { index: Index })"
                                    @click.stop="$emit('RemoveDataBlockEvent', Index);" class="text-danger" />
                        </b-button>
                </b-col>
            </b-row>
            
        </b-card-header>
        <b-collapse v-model="collapsed" accordion="dataAccordion">
            <b-card-body class="position-relative py-1">
                <!-- TODO : Répéter ce bloc : Donnée 1, donnée 2, ... Chacun de ces blocs contient des filtres + d'autres
                 paramètres avancés spécifiques au bloc ==> Faire un composant EvoData.vue pour gérer ça ?
                Includes/excludes commun à tous les blocs ==> A mettre dans Evolution.vue
                -->
                <!-- Synthesis -> "Synthèse" -->
                <b-row class="font-weight-bold">{{ $t('Synthesis') }}</b-row>

                <b-row class="py-1">
                    <b-button v-for="syn in listEnums('SynthesisType|' + this.Feature)" :key="syn.Id"
                    @click="selectSynthesis(syn.Id)" :pressed="dataValue.Synthesis === syn.Id" size="sm"
                    :disabled="checkSynthesisType(syn.Id)" variant="outline-gray-dark" class="mr-1 mb-2 flex-grow-1 text-black">
                    {{ syn.Label }}
                    </b-button>
                </b-row>

                <!-- Nature du relevé (Afficher uniquement en synthèse relevé)  -->
                <template v-if="dataValue.Synthesis == 'Statement'">
                    <hr class="m-0 mb-2 bg-gray" />
                    <b-row class="mb-1">
                        <b-button v-for="state in listEnums('StatementType|' + this.Feature)" :key="state.Id"
                                  @click="updateNature(state.Id)" :pressed="dataValue.NatureStatements && dataValue.NatureStatements.includes(state.Id)"
                                  pill size="sm" class="mr-1 mb-1 flex-grow-1 border border-gray text-black bg-gray-light">
                            {{ state.Label }}
                        </b-button>
                    </b-row>
                </template>

                <!-- Nature du Budget (Afficher uniquement en synthèse budget) -->
                <template v-if="dataValue.Synthesis == 'Budget'">
                    <hr class="m-0 mb-2 bg-gray" />
                    <b-row align-h="center">
                        <b-button-group class="d-flex btn-gray-light rounded-pill border border-gray flew-grow-1">
                            <!-- InvoiceDate -> "Date de facturation" -->
                            <b-button @click="dataValue.UsePaymentDate = false" :pressed="!dataValue.UsePaymentDate" pill variant="outline-white"
                                  size="sm">{{ $t('InvoiceDate') }}</b-button>
                            <!-- PaymentDate -> "Date de paiement" -->
                            <b-button @click="dataValue.UsePaymentDate = true" :pressed="dataValue.UsePaymentDate" pill variant="outline-white"
                                  size="sm">{{ $t('PaymentDate') }}</b-button>
                        </b-button-group>
                    </b-row>
                </template>

                <!-- Nature du distributeur (Afficher uniquement en synthèse distributeur) -->
                <template v-if="dataValue.Synthesis == 'Distributor'">
                    <hr class="m-0 mb-2 bg-gray" />
                    <b-row align-h="center">
                        <b-button-group class="d-flex btn-gray-light rounded-pill border border-gray flew-grow-1">
                            <b-button v-for="issuer in listEnums('IssuerType|' + this.Feature)" :key="issuer.Id" @click="dataValue.IssuerType = issuer.Id"
                                :pressed="dataValue.IssuerType === issuer.Id" pill size="sm" variant="outline-white" >
                                {{ issuer.Label }}
                            </b-button>
                        </b-button-group>
                    </b-row>
                </template>

                <!-- Type de données -->
                <!-- Datas-> "Données" -->
                <b-row class="font-weight-bold">{{ $t('Datas') }}</b-row>
                <b-row>
                    <b-button v-for="dataType in listEnums('SynthesisData|' + this.Feature)" :key="dataType.Id"
                              @click="selectType(dataType); $emit('ChangeConfigCommonWorkDataEvent', Index);"
                              :pressed="dataValue.Type === dataType.Id"
                              :disabled="(dataValue.Synthesis == 'Statement' || dataValue.Synthesis == 'Distributor') && dataType.Label.includes($t('Cost').toString())"
                              size="sm" variant="outline-gray-dark" class="mr-1 mb-2 flex-grow-1 text-black">
                        {{ dataType.Label }}
                    </b-button>
                </b-row>

                <!-- Liste des énergies -->
                <hr v-if="dataValue.Type == 'Consumption'" class="my-1 bg-gray" />
                <b-row v-if="dataValue.Type == 'Consumption'">
                    <b-button v-for="expendable in filteredExpendable()" :key="expendable.Id"
                              @click="dataValue.FilterExpendables = expendable.Id.toString(); $emit('ChangeConfigCommonWorkDataEvent', Index);"
                              :pressed="dataValue.FilterExpendables === expendable.Id.toString()" pill size="sm" variant="gray-light"
                              class="mr-1 mb-2 flex-grow-1 border border-gray text-black">
                        {{ expendable.Label }}
                    </b-button>
                </b-row>

                <!-- Flux Energétique -->
                <template v-if="checkSynthesisHasFlows()">
                    <!-- Flow -> "Flux" -->
                    <b-row class="font-weight-bold">{{ $t('Flow') }}</b-row>
                    <b-row>
                        <b-button v-for="flow in listEnums('FlowType|' + this.Feature)" :key="flow.Id"
                                  @click="dataValue.ConsumptionFlow = flow.Id; $emit('ChangeConfigCommonWorkDataEvent', Index);"
                                  :pressed="dataValue.ConsumptionFlow === flow.Id" size="sm" :disabled="checkFlowType(flow.Id)"
                                  variant="outline-gray-dark" class="mr-1 mb-1 flex-grow-1 text-black">
                            {{ flow.Label }}
                        </b-button>
                    </b-row>
                </template>

                <!-- Flux Financier - Partie masquée pour le moment à la demande de SLavina -->                 
                <template v-if="dataValue.Type.includes('Cost') && false" > 
                    <!-- Flow -> "Flux" -->
                    <b-row class="font-weight-bold">{{ $t('Flow') }}</b-row>
                    <b-row>
                        <b-button v-for="flow in listEnums('FinancialFlow|' + this.Feature)" :key="flow.Id"
                                  @click="dataValue.FinancialFlow = flow.Id; $emit('ChangeConfigCommonWorkDataEvent', Index);"
                                  :pressed="dataValue.FinancialFlow === flow.Id" size="sm" variant="outline-gray-dark" class="mr-1 mb-1 flex-grow-1 text-black">
                            {{ flow.Label }}
                        </b-button>
                    </b-row>
                </template>

                <hr class="my-1 bg-gray" />

                <!-- Facteurs -->
                <b-row class="py-1 justify-content-between">
                    <!-- Factors -> "Facteurs" -->
                    <b-col class="px-0 font-weight-bold">
                        {{ $tc('Factors', 2) }}

                        <b-icon icon="question-circle" role="button" v-b-tooltip.hover.noninteractive :title="$t('ClickHereToKnowFactorStates')" @click="factorStatesVisible = true" /> <!-- Cliquez ici pour connaître les différents états d'un facteur -->
                    </b-col>
                    <b-col cols="auto" class="text-right px-1">
                        <hsc-menu-style-custom>
                            <hsc-menu-button-menu :menuZIndex="1000" class="w-100">
                                <!-- Add -> "Ajouter" -->
                                <b-link :id="$id('factorListState')" :class="['text-' + Variant, { 'text-decoration-none text-muted': listItems('Factors').length == 0}]">{{ $t('Add') }}</b-link>
                                <template slot="contextmenu" v-for="(factor, index) of listItems('Factors')">
                                    <hsc-menu-item :disabled="selectedFactors.find(x => x.Id == factor.Id) != undefined" :label="factor.Label" @click="addFactor(factor.Id)" class="text-left" :key="index" />
                                </template>
                            </hsc-menu-button-menu>
                        </hsc-menu-style-custom>
                    </b-col>
                </b-row>

                <!-- Appel dynamique d'un composant affichant les informations des différents états d'un facteur -->
                <component v-if="factorStatesVisible" v-bind:is="'FactorStates' + Feature" :Variant="Variant" :Visible.sync="factorStatesVisible" />

                <b-tooltip v-if="listItems('Factors').length == 0" :target="$id('factorListState')" noninteractive triggers="hover">
                    {{ $t('NoFactorsAvailable') }}
                </b-tooltip>

                <b-row v-if="selectedFactors.length > 0" class="text-gray-dark font-italic px-0">
                    {{ $t('Ratio', { symbol: synDataSymbol, ratio: factorRatio }) }}
                </b-row>
                <!-- AddFactorForRatio -> "Ajouter un facteur pour créer un ratio" -->
                <b-row v-else class="text-gray-dark font-italic px-0"> {{ $t('AddFactorForRatio') }}</b-row>

                <!-- Liste des facteurs selectionnés -->
                <b-row align-v="center" class="py-1">
                    <table class="table m-0 p-0 align-middle">
                        <draggable @change="updateDraggableFactors" v-model="selectedFactors" tag="tbody">
                            <FactorBlock v-for="(selectedFactorItem, index) in selectedFactors" :key="selectedFactorItem.Id"
                                         :Factor.sync="dataValue.Factors[index]"
                                         :FactorLabel="selectedFactorItem.Label"
                                         :Feature="Feature"
                                         @RemoveFactorEvent="removeFactor(index)"
                                         @UpdateRatioEvent="updateRatio()" />
                        </draggable>
                    </table>
                </b-row>

                <!-- Répartition -->
                <hr v-if="UseDistribution" class="my-1 bg-gray" />

                <!-- Liste des répartitions -->
                <b-row v-if="UseDistribution" align-v="center" class="py-1 justify-content-between">
                    <b-col cols="3" class="px-0">
                        <!-- Distribution -> "Répartition" -->
                        {{ $t('Distribution') }}
                    </b-col>
                    <b-col class="px-1">
                        <!-- Merci de ne pas mettre de :disabled="Feature === 'Benchmarking' && Index > 1" en dur sur ce b-form-select !!🤮
                        ==> Créer plutôt une Prop recevant le comportement à adopter pour activer/désactiver cette liste si besoin -->
                        <b-form-select id="distributions"
                                       :options="filteredDistributions()"
                                       value-field="Id"
                                       text-field="Label"
                                       plain
                                       v-model="dataValue.Distribution"
                                       class="w-100" />
                    </b-col>
                </b-row>

                <hr class="my-1 bg-gray" />

                <!-- Filtres -->
                <b-row cols="2" class="py-1 justify-content-between">
                    <!-- Filters -> Filtres -->
                    <b-col class="px-0 font-weight-bold">{{ $t('Filters')}}</b-col>
                    <b-col class="text-right px-1">
                        <!-- Fill -> Renseigner -->
                        <b-link @click="filterVisible = true;" :class="'text-' + Variant">{{ $t('Fill')}}</b-link>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-gray-dark font-italic px-0">
                        {{ $tc('SelectedFilters', dataValue.Filters.length, {n : dataValue.Filters.length} ) }}
                    </b-col>
                </b-row>

                <!-- Modale de sélection de filtres -->
                <Filters v-if="filterVisible" :Visible.sync="filterVisible" :PerimeterList.sync="perimeterList"
                         :DataType.sync="dataValue.Type" :Distribution.sync="dataValue.Distribution" :Purposes.sync="dataValue.FilterPurposes"
                         :Uses.sync="dataValue.FilterUsages" :Expendable.sync="dataValue.FilterExpendables" :Costs.sync="dataValue.FilterCostDetails" :Providers.sync="dataValue.FilterProviders"
                         :Tariffs.sync="dataValue.FilterTariffs" :Contracts.sync="dataValue.FilterContracts" :SModel.sync="dataValue.BudgetModelId"
                         :SFormulaCode.sync="dataValue.FilterBudgetModel" :Owner.sync="dataValue.FilterOwner" :ObjectType.sync="dataValue.FilterObjectType"
                         :SubscriptionHolder.sync="dataValue.FilterSubscriptionHolder" :PayingInvoice.sync="dataValue.FilterPayingInvoice"
                         :SelectedFilters.sync="dataValue.Filters" :Variant="Variant" />

                <hr class="my-1 bg-gray" />

                <!-- Options avancées -->
                <b-row cols="2" class="py-1 justify-content-between">
                    <!-- AdvancedOption -> Option Avancées -->
                    <b-col class="px-0 font-weight-bold">{{ $t('AdvancedOptions')}}</b-col>
                    <b-col class="text-right px-1">
                        <!-- Fill-> Renseigner -->
                        <b-link @click="settingsVisible = true;" :class="'text-' + Variant">{{ $t('Fill')}}</b-link>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-gray-dark font-italic px-0">
                        {{ $tc('SelectedSettings', selectedSettings.length, {n : selectedSettings.length}  ) }}
                    </b-col>
                    <!-- NoOptionSelected -> Aucune option sélectionnée -->
                    <!-- <b-col v-else class="text-gray-dark font-italic px-0"> {{ $t('NoOptionSelected')}}</b-col> -->
                </b-row>

                <!-- Modale de sélection des options avancées -->
                <AdvancedSettings v-if="settingsVisible" :Visible.sync="settingsVisible" :IsCorrector.sync="isCorrector" :Correctors.sync="dataValue.Correctors"
                                  :SlidingYear.sync="dataValue.SlidingYear" :IsAccounting.sync="dataValue.IsAccounting"
                                  :WithoutEstimated.sync="dataValue.WithoutEstimated" :Compare.sync="dataValue.Compare"
                                  :Dissociate.sync="dataValue.Dissociate" :Cumulate.sync="dataValue.Cumulate" :SynthesisType="dataValue.Synthesis"
                                  :DisplaySettingsVisible="DisplaySettingsVisible" :SelectedSettings.sync="selectedSettings" :Variant="Variant" />

            </b-card-body>
        </b-collapse>
        <!-- Affichage récapitulatif du DataBlock lors du collapse -->
        <b-collapse :visible="!collapsed" @shown="updateDataResume">
            <b-card-body class="py-1">
                <b-row v-for="data in dataResume" :key="data.type" class="text-muted" align-h="between">
                    <b-col class="text-gray-dark px-0">{{ data.type }}</b-col>
                    <b-col class="text-gray-dark text-left font-weight-bold px-0">{{ data.value }}</b-col>
                </b-row>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script lang="ts">
    import { Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';
    import Component from 'vue-class-component';
    import draggable from 'vuedraggable';
    import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
    import ListItem from "@/types/fields/ListItem";
    import Multiselect from 'vue-multiselect';
    import Filters from './Datablock/Filters.vue';
    import AdvancedSettings from './Datablock/AdvancedSettings.vue';
    import EnumItem from '@/types/fields/EnumItem';
    import Mask from '@/types/Config/Mask';
    import Data from '@/types/Config/Data';
    import FactorBlock from './Datablock/FactorBlock.vue';
    import Factor from '@/types/Config/Factor';
    
    // Composants pour l'affichage des informations des états de facteurs
    import FactorStatesEvolution from './Datablock/Evolution/FactorStates.vue';
    import FactorStatesBenchmarking from './Datablock/Benchmarking/FactorStates.vue';

    /** Traductions */
    import locales from "./locales/DataBlock.json";
     
    /** Block de données de paramétrage */
    @Component({
        components: {
            'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
            draggable,
            Multiselect,
            Filters,
            AdvancedSettings,
            FactorBlock,
            FactorStatesEvolution,
            FactorStatesBenchmarking
        },
        i18n: { messages: locales }
    })
    export default class DataBlock extends Vue {
		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;

        /** Nom de la fonctionnalité où se trouve le DataBlock (gestion affichage diff.) */
        @Prop()
        public Feature!: string;

        /** Getter pour obtenir une liste */
        @Getter('GetListItems')
        private listItems!: (listName: string) => ListItem[];

        /** Getter pour obtenir une liste d'enumération */
        @Getter('GetListEnums')
        private listEnums!: (listName: string) => EnumItem[];

        /** Getter pour obtenir une liste filtrée selon le périmètre de l'utilisateur */
        @Getter('GetPerimeterItems')
        private perimeterItems!: (listName: string) => any[];

        /** Index du bloc de données */
        @Prop()
        public Index!: number;

        /** Nombre de données */
        @Prop()
        public NbData!: number;

        /** Données manipulées localement par le bloc de données */
        @PropSync('DataValue')
        public dataValue!: Data;

        /** Indique si la partie des options d'affichage est visible ou non */
        @Prop({ default: () => false })
        public DisplaySettingsVisible!: boolean;

        /** Permet d'afficher ou non la répartition */
        @Prop()
        public UseDistribution!: boolean;

        /** Chaine des listes à récupérer selon le périmètre de l'utilisateur */
        private perimeterList: string = "Expendable,UsageType,Purpose,SynthesisType,Provider,Tariff,Contract,Owner,SubscriptionHolder,ObjectType,PayingInvoice,Flow";

        /** Correspond à l'unité à afficher selon le type de données sélectionné */
        private synDataSymbol: string = "";

        /** Indique sur le DataBlock est déplié ou replié */
        private collapsed: boolean = true;

        /** Indique si on affiche la modale de selection de filtres */
        private filterVisible: boolean = false;

        /** Indique si on affiche la modale de sélection des options avancées */
        private settingsVisible: boolean = false;

        /** Indique si on affiche ou non la modale des informations des différents états d'un facteur */
        private factorStatesVisible: boolean = false;

        /** Texte du résumé du DataBlock quand il est replié */
        private dataResume: {type: string, value: string}[] = [];

        /** Permet d'obtenir le resumé de la donnée quand elle est repliée */
        @Watch("NbData", { immediate : false })
        private updateDataResume(){
            // Réinitialisation
            this.dataResume = [];

            console.debug("DataBlock - updateDataResume");

            // Ajout des données
            if(this.listEnums('SynthesisType|' + this.Feature).length > 0 && this.dataValue.Synthesis)
            // Synthesis -> Synthèse
                this.dataResume.push({ type: this.$t('Synthesis').toString(), value: this.listEnums('SynthesisType|' + this.Feature).find(x => x.Id == this.dataValue.Synthesis).Label});
            
            // Si type synthese Relevé est sélectionné, on récupère le(s) type(s) de relevé
            if(this.dataValue.Synthesis == "Statement" && this.listEnums('StatementType|' + this.Feature).length > 0){
                let statement = "";
                this.listEnums('StatementType|' + this.Feature).filter(x => this.dataValue.NatureStatements.includes(x.Id)).forEach(x => statement += x.Label + ", " );
                // StatementType -> Type de relevé
                this.dataResume.push({ type: this.$t('StatementType').toString(), value: statement.slice(0, -2)});
            } 
            
            if(this.listEnums('SynthesisData|' + this.Feature).length > 0)
            // DataType -> Type de données
                this.dataResume.push({ type: this.$t('DataType').toString(), value: this.listEnums('SynthesisData|' + this.Feature).find(x => x.Id == this.dataValue.Type).Label});
            
            if(this.listEnums('FlowType|' + this.Feature).length > 0)
            // Flow -> Flux
                this.dataResume.push({ type: this.$t('Flow').toString(), value: this.listEnums('FlowType|' + this.Feature).find(x => x.Id == this.dataValue.ConsumptionFlow).Label});
            
            // Si des facteurs sont renseignés
            if(this.dataValue.Factors.length > 0)
            //  Factor ->Facteur
                this.dataResume.push({ type: "Facteur", value: this.synDataSymbol + this.factorRatio });
            
            if(this.listEnums('SynthesisDistribution|' + this.Feature).length > 0)
            // Distribution -> Répartition
                this.dataResume.push({ type: this.$t('Distribution').toString(), value: this.dataValue.Distribution != "None" ? this.listEnums('SynthesisDistribution|' + this.Feature).find(x => x.Id == this.dataValue.Distribution).Label : this.$t('NoneFeminine').toString()});
            // Filters -> Filtre | 'Filter':  'None' -> " Filtre" :  "Aucun" 
            this.dataResume.push({ type: this.$t('Filters').toString(), value: this.dataValue.Filters.length > 0 ? this.dataValue.Filters.length + " " + this.$t('Filter').toString() :  this.$t('None').toString() });
            // Option Avancée -> AdvancedOption | 'AdvancedOptions' + " " : 'NoneFeminine' -> " option(s) avancée(s) " : "Aucune"
            this.dataResume.push({ type: this.$t('AdvancedOption').toString(), value: this.selectedSettings.length > 0 ? this.selectedSettings.length + " " + this.$t('AdvancedOptions').toString() + " " : this.$t('NoneFeminine').toString() });
        }

        //#region Type de synthèse

        /**
         * Permet de sélectionner le type de synthèse
         * @param id identifiant de la synthèse sélectionnée
         */
        private selectSynthesis(id: string){

            // Si type de synthèse est "Relevé" ou "Distributeur" et que le type de donnée est un coût, passer le type d'énergie sur Energie Finale Fact
            if((id == "Statement" || id == "Distributor") && this.dataValue.Type.includes("Cost"))
                this.dataValue.Type = "FinalEnergy";

            // Si Synthesis sélectionné est Relevé, sélectionner toutes les natures de relevé
            // Sinon on vide la sélection
            if(id == 'Statement'){
                let tmpStatementType = [...this.listEnums('StatementType|' + this.Feature)];
                tmpStatementType.forEach(
                    x => this.dataValue.NatureStatements.push(x.Id)
                );
            }
            else
                this.dataValue.NatureStatements = [];

            // Si la synthèse sélectionné est différent de 'Distributeur', on passe l'info IssuerType à 'Distributor'
            if(id != "Distributor")
                this.dataValue.IssuerType = "Distributor";

            this.dataValue.Synthesis = id;

            // Sur le changement de type de synthèse, vérifier si le flux actuellement sélectionné n'est pas présent pour la synthèse sélectionnée afin de sélectionner la première valeur disponible
            if(!(this.perimeterItems(this.dataValue.Synthesis + "Flow").includes(this.dataValue.ConsumptionFlow)))
                this.dataValue.ConsumptionFlow = this.perimeterItems(this.dataValue.Synthesis + "Flow")[0];
        }

        //#endregion Type de synthèse

        //#region Nature de Relevé

        /**
         * Permet l'ajout d'un relevé et la suppression si existant 
         * @param id identifiant de la nature du relevé
         */
        private updateNature(id: string) {
            console.debug("DataBlock - updateNature - Debut");

            console.debug("DataBlock - updateNature - dataValue.NatureStatements", this.dataValue.NatureStatements);
            console.debug("DataBlock - updateNature - id", id);

            /** tableau des natures de relevé */

            // Si Nature existe, on la supprime
            if(this.dataValue.NatureStatements.find(x => x == id))
            {
                let index = this.dataValue.NatureStatements.findIndex(x => x == id); 
                this.dataValue.NatureStatements.splice(index, 1);
            }    
            else
            {
                this.dataValue.NatureStatements.push(id);
            }
        }

        //#endregion Nature de Relevé

        //#region Energies

        /** Liste des energies sélectionnées pour le filtre */
        private filterEnergies: { Id: number, Label: string }[] = [];

        /** Permet de récupérer la liste des énergies sélectionnées */
        @Watch('dataValue.FilterExpendables', { immediate: true })
        protected updateFilterExpendable() {
            if (this.dataValue.FilterExpendables){
                this.filterEnergies = this.listItems("Expendable").filter(x => (this.dataValue.FilterExpendables.split(","))
                    .includes(x.Id.toString()));
			}
        }

        /** Permet de filtrer la liste des énergies disponibles */
        private filteredExpendable() {
            let filterExpendable: { Id: number, Label: string }[] = [];
            filterExpendable = this.listItems('Expendable').filter(x => (this.perimeterItems('Expendable').includes(x.Id)));

            console.debug("DataBlock - filteredExpendable - filterExpendable : %O", filterExpendable);

            return filterExpendable;
        }

        //#endregion Energies

        /** Permet de déterminer la présence de flux énergétiques par rapport à la synthèse sélectionnée */
        private checkSynthesisHasFlows(): boolean {
            // Filtre les flux par rapport à la synthèse sélectionnée
            let synthesisFlow: string[] = this.perimeterItems(this.dataValue.Synthesis + "Flow");

            console.debug("DataBlock - checkSynthesisHasFlows - synthesis : %O - synthesisFlow : %O", this.dataValue.Synthesis, synthesisFlow);

            // Renvoie si au moins 2 éléments ont été trouvé et que le type de donnée n'est pas un coût
            return synthesisFlow.length > 1 && !this.dataValue.Type.includes('Cost');
        }

        //#region Répartitions

        /** Liste des distributions filtrées selon la feature */
        private filteredDistributions(){
            let filteredDistributions: EnumItem[] = [...this.listEnums("SynthesisDistribution|" + this.Feature)];

            // Energies (Appliquer sur la premiere donnée uniquement en Benchmarking)
            if(this.dataValue.Type == "Consumption"){
                filteredDistributions = filteredDistributions.filter(x => x.Id != "Expendable");
            }

            // Type de facture
            if(this.dataValue.Synthesis != "Budget"){
                filteredDistributions = filteredDistributions.filter(x => x.Id != "Nature");
            }

            // Distributeur
            if(this.dataValue.Synthesis != "Distributor"){
                filteredDistributions = filteredDistributions.filter(x => x.Id != "Distributor");
            }

            // Détail par tranche/catégorie ... 
            if(this.dataValue.Type.includes("Cost")){
                filteredDistributions = filteredDistributions.filter(x => x.Id != "ConsumptionDetail");
            }
            else{
                filteredDistributions = filteredDistributions.filter(x => x.Id != "CostAllDetail");
                filteredDistributions = filteredDistributions.filter(x => x.Id != "CostDetail");
            }
       
            // Ajout Distribution Aucune en premiere position
            filteredDistributions.unshift({ Id: "None", Label: this.$t('NoneFeminine').toString(), Extras: {} });

            return filteredDistributions;
        }

        //#endregion Répartitions

        //#region Facteurs

        /** Liste correspondant aux facteurs sélectionnés */
        private selectedFactors: ListItem[] = [];

		/** Alimenter la liste des facteurs sélectionnées  */
		private updateFactors(allfactors, synthesisData) {
			console.debug("DataBlock - updateFactors - allFactors : %O - synthesisData : %O", allfactors, synthesisData);

			let ratio : string = "";

			for (let f of this.dataValue.Factors) {
				let fact = allfactors.find(x => x.Id.toString() == f.Id);
				console.debug("DataBlock - updateFactors - fact", fact);

				this.synDataSymbol = synthesisData.find(s => s.Id == this.dataValue.Type).Extras.Symbol;
                if (!this.selectedFactors.includes(fact)) {
				    this.selectedFactors.push({Id: fact.Id, Label: fact.Label, Extras: fact.Extras});
                }

				ratio += f.Operator + '' + fact.Extras.Unit;
			}

			this.factorRatio = ratio;
		}

        /** Correspond au ratio des facteurs ( ex: kWh EF/h ) */
		private factorRatio: string = "";

		/** Permet le changement du ratio apres un drag&drop dans la liste des facteurs sélectionnés */
		private updateDraggableFactors(item) {
			if (this.selectedFactors) {

				console.debug("updateDraggableFactors - item - ", item);

				let tmpFactors: Factor = this.dataValue.Factors[item.moved.newIndex];
				this.dataValue.Factors[item.moved.newIndex] = this.dataValue.Factors[item.moved.oldIndex];
				this.dataValue.Factors[item.moved.oldIndex] = tmpFactors;

				this.updateRatio();
			}
		}

        /**
         * Ajoute le facteur à la liste des facteurs sélectionnés et recalcule le ratio
         * @param id identifiant du facteur
         */
        private addFactor(id: number) {
            let factor: ListItem = this.listItems('Factors').find(f => f.Id == id);

            if (factor) {
                // récupération du symbole d'unité du type de données
                this.synDataSymbol = this.listEnums('SynthesisData|' + this.Feature).find(s => s.Id == this.dataValue.Type).Extras.Symbol;

                // Si le facteur n'existe pas dans la liste de selection, on l'ajoute
                if (!this.selectedFactors.includes(factor)) {
                    this.selectedFactors.push(factor);

                    // par défaut, on ajoute tous les nœuds du facteur => Filter = []
                    this.dataValue.Factors.push(Factor.Create(factor.Id.toString(), this.Feature));

                    this.updateRatio();
                }
            }
        }

		/**
		 * Supprime le facteur à la liste des facteurs sélectionnés
		 * @param index
		 */
         private removeFactor(index: number) {
            this.selectedFactors.splice(index, 1);
            this.dataValue.Factors.splice(index, 1);

            this.updateRatio();

            console.debug("removeFactor - selectedFactors post splice", this.selectedFactors);
        }   

        /** Met à jour le ratio des facteurs sélectionnés */
        private updateRatio(){
            let ratio: string = "";

            for (let i = 0; i < this.dataValue.Factors.length; i++) {
                ratio += this.dataValue.Factors[i].Operator + '' + this.selectedFactors[i].Extras.Unit;
            }

            this.factorRatio = ratio;
        }

        //#endregion Facteurs

       
        //#region Options Avancées

        /** Indique si la correction degrés jour est active ou non */
        private isCorrector: boolean = false;

        /** Liste des options sélectionnées */
        private selectedSettings : {Name: string, Values : string}[] = [];

         /** Permet de récupérer la liste des options avancés sélectionnés dans la configuration */
        private getSelectedSettings(){

            this.selectedSettings = [];

            if(this.dataValue.Correctors){
                this.isCorrector = true;
                this.selectedSettings.push({Name: "isCorrector", Values: this.dataValue.Correctors});
            }

            if(this.dataValue.SlidingYear)
                this.selectedSettings.push({Name: "isSlidingYear", Values: ""});

            if(this.dataValue.WithoutEstimated)
                this.selectedSettings.push({Name: "isWithoutEstimated", Values: ""});

            if(this.dataValue.IsAccounting)
                this.selectedSettings.push({Name: "isAccounting", Values: ""});

            if(this.dataValue.Compare)
                this.selectedSettings.push({Name: "isCompare", Values: ""});

            if(this.dataValue.Dissociate)
                this.selectedSettings.push({Name: "isDissociate", Values: ""});

            if(this.dataValue.Cumulate)
                this.selectedSettings.push({Name: "isCumulated", Values: ""});
        }
        //#endregion Options Avancées

        /** Masque de configuration sélectionné */
        @Prop()
        public SelectedMask !: Mask;

        /** Action à réaliser quand le masque de configuration est modifié */
        @Watch('SelectedMask')
        private updateSelectedMask(){
            // Mise à jour des options avancées
            this.getSelectedSettings();

            // Mise à jour des facteurs
            this.selectedFactors = [];
            this.updateFactors(this.listItems('Factors'), this.listEnums('SynthesisData|' + this.Feature))
        }

        /** Permet l'affichage d'un overlay lorsqu'aucun type de synthèse est disponible */
        @PropSync('ShowOverlay', {default: () => { false }})
        public showOverlay!: boolean;

        /**
         * Selection du type de données + sélection energies par défaut pour selection Consumption
         * @param dataType type de données sélectionnée
         */
        private selectType(dataType) {
            this.dataValue.Type = dataType.Id;
            this.synDataSymbol = dataType.Extras.Symbol;

            // Si aucun filtre d'énergies existe au chgt de type de donnée, on met la valeur d'énergie sélectionnée à null
            if(!this.dataValue.Filters.find(x => x.Name == 'Expendable')){
                this.dataValue.FilterExpendables = null;
            }

            // Si le type de données ne correspond pas à un coût, on met le flux financier à débit par défaut
            if(!dataType.Id.includes('Cost'))
                this.dataValue.FinancialFlow = "Debit";

            // Si type de donnée est Conso/Livraison, on récupère la première énergie disponible et met la répartition à "Aucune" si celle-ci était sur "Énergie" 
            if(dataType.Id == "Consumption"){
                this.dataValue.FilterExpendables = this.perimeterItems('Expendable')[0].toString();

                // Si filtres énergies existant, on le supprime
                if(this.dataValue.Filters.find(x => x.Name == 'Expendable'))
                    this.dataValue.Filters.splice(this.dataValue.Filters.findIndex(x => x.Name == 'Expendable'), 1);
                
                // Si répartition sélectionnée est 'Expendable', on la passe à "None"
                if(this.dataValue.Distribution == "Expendable")
                    this.dataValue.Distribution = "None";
            }
        }

        /**
         * Filtre la liste des synthèses selon la liste du périmètre de l'utilisateur
         * @param synId
         */
        private checkSynthesisType(synId) {
            let synContained: boolean = this.perimeterItems("SynthesisType") ? !(this.perimeterItems("SynthesisType").includes(synId)) : false;

            return synContained;
        }

        /**
         * Filtre la liste des flux selon la liste du périmètre de l'utilisateur
         * @param flow
         */
        private checkFlowType(flow) {
            // Filtre les flux par rapport à la synthèse sélectionnée
            let synthesisFlow: string[] = this.perimeterItems(this.dataValue.Synthesis + "Flow");

            console.debug("DataBlock - checkFlowType - flow : %O | synthesisFlow : %O", flow, synthesisFlow);

            return synthesisFlow ? !(synthesisFlow.includes(flow)) : false;
        }

        /** 
         * Pointeurs vers fonction pour désactiver watchers
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
        private unwatchGetListItems = undefined;
        private unwatchGetListEnums = undefined;
        private unwatchGetPerimeterItems = undefined;

        created() {
            // Afin de vérifier les deux états de chargement pour la liste des facteurs (chargement des facteurs → chargement des types de données)
            if(this.selectedFactors.length == 0)
                this.unwatchGetListItems = this.$store.watch((state, getters) => getters['GetListItems']('Factors'), allFactors => {
                    console.debug("DataBlock - Created - Watch - Factors", allFactors)

                        // Liste des facteurs est chargée
                        if(allFactors.length > 0 ){
                            this.unwatchGetListEnums = this.$store.watch((state, getters) => getters['GetListEnums']('SynthesisData|' + this.Feature), synthesisData => {
                                console.debug("DataBlock - Created - Watch - SynthesisData", synthesisData)

                                console.debug("DataBlock - Created - Watch - selectedFactors.length", this.selectedFactors.length)

                                // Liste des type des données chargée et aucun facteurs sélectionnées
                                if(synthesisData.length > 0 && this.selectedFactors.length == 0){
                                    console.debug("DataBlock - Created - Factors Update")
                                    this.updateFactors(allFactors, synthesisData);
                                }
                            }, { immediate: true });
                        }
                }, { immediate: true });

            // Vérification sélection premier type de synthèse disponible
            this.unwatchGetPerimeterItems = this.$store.watch((state, getters) => getters['GetPerimeterItems']('SynthesisType'), allSynthesis => {  
                // Liste des types de synthese récupéré
                if(allSynthesis.length > 0)
                {
                    console.debug("DataBlock - created - watch - allSynthesis : %O | this.dataValue.Synthesis : %O | !this.dataValue.Synthesis : %O", allSynthesis, this.dataValue.Synthesis, !this.dataValue.Synthesis);
                    this.showOverlay = false;

                    //Problème sur réouverture d'un widget → ajout vérification ?
                    // !this.dataValue.Synthesis retourne true quand il y a pas de sélection (retour console pour dataValue.Synthesis = 0 ???)
                    if (allSynthesis.includes('Invoice') && !this.dataValue.Synthesis)
                        this.dataValue.Synthesis = 'Invoice';
                    else if(!this.dataValue.Synthesis){
                        console.debug("DataBlock - created - watch - D - allSynthesis 0 : ", allSynthesis.at(0));
                        this.dataValue.Synthesis = allSynthesis.at(0);

                        // /!\ Obligation de passer par allSynthesis.at(0) pour entrer dans la condition /!\
                        // Si le premier élément sélectionnable est 'Statement', sélectionner également TOUTES les natures de relevé.
                        if(allSynthesis.at(0) == 'Statement'){
                            let tmpStatementType = [...this.listEnums('StatementType|' + this.Feature)];

                            console.debug("DataBlock - created - watch - tmpStatementType : %O ", tmpStatementType);

                            tmpStatementType.forEach(
                                x => this.dataValue.NatureStatements.push(x.Id)
                            );
                        }
                    }
                }  
                else
                    this.showOverlay = true; 
                    console.debug("DataBlock - created - dataValue.Synthesis", this.dataValue.Synthesis, this.showOverlay);
            }, { immediate: false });
        }

        mounted() {
            /** Chargement des options sélectionnées */
            this.getSelectedSettings();
        }

        beforeDestroy() {
            // Libère les watchers
            if (this.unwatchGetListItems)
                this.unwatchGetListItems();
            if (this.unwatchGetListEnums)
                this.unwatchGetListEnums();
            if (this.unwatchGetPerimeterItems)
                this.unwatchGetPerimeterItems();
        }
    }

</script>

<style scoped>

    /* Permet aux en-tetes des b-card d'afficher le curseur comme sur un bouton */
    .card-header:hover {
        cursor: pointer;
    }
</style>